module.exports = __webpack_public_path__ + "static/media/disko.0342efd9.svg";